/**
 * Single source of truth for the entretien-consulting FAQ.
 * Used by layout.tsx (JSON-LD) AND page.tsx (visible <FaqSection>).
 */

import type { FaqItem } from "@/components/landing/FaqSection";

export const consultingFaqFr: FaqItem[] = [
  {
    q: "Quels types de case studies Velyq génère-t-il ?",
    a: "Profitability, market sizing, market entry, M&A, growth strategy, pricing, cost reduction, new product launch, turnaround. Plus des cas sectoriels (tech, retail, banque, santé, énergie) et des cas maison McKinsey/BCG/Bain reconstitués.",
  },
  {
    q: "L'IA challenge-t-elle comme un vrai interviewer MBB ?",
    a: "Oui. L'IA interrompt si tu pars dans le flou, challenge tes hypothèses, injecte des données au milieu du case, te demande de synthétiser en Top-Down (Pyramid Principle), et score ta communication, ta structure et ta rigueur MECE.",
  },
  {
    q: "Velyq enseigne-t-il les frameworks classiques ?",
    a: "Oui. Mini-modules intégrés : MECE, Pyramid Principle, Issue Tree, Profitability (Revenue/Cost), 4P Marketing, Porter 5 Forces, 3C. Tu apprends les frameworks puis tu les appliques en case, et l'IA te corrige sur l'usage.",
  },
  {
    q: "Je vise McKinsey / BCG / Bain, c'est adapté ?",
    a: "Oui. Mode MBB avec cas rigoureux, timing 45 min, attente de structure explicite (\"Before diving in, I'd like to…\"), focus sur la synthèse chiffrée. Pour les PEI McKinsey, module fit questions dédié (leadership, teamwork, entrepreneurial drive).",
  },
  {
    q: "Et pour Roland Berger, Kearney, Oliver Wyman, Strategy& ?",
    a: "Oui. Mode Tier-1 avec cases moins stylisés que MBB mais tout aussi rigoureux. Pour Roland Berger FR, focus sur les cas industries/automobile/banque qui sortent souvent en entretien.",
  },
  {
    q: "Je suis en école de commerce / ingé, c'est pour moi ?",
    a: "Parfait. Velyq est très utilisé par les étudiants HEC, ESSEC, ESCP, X, CentraleSupélec pour leurs entretiens stage/CDI consulting. Mode junior avec cases plus guidés pour construire l'intuition, puis passage au niveau MBB senior.",
  },
  {
    q: "Combien de cases pour être prêt ?",
    a: "Pour un final round MBB : 30-50 cases complets sur 6-8 semaines. Pour un entretien Tier-2 ou boutique stratégie : 15-25 cases. Velyq alterne case fullcomplet, case flash (15 min) et drills ciblés (juste market sizing, juste synthèse).",
  },
];

export const consultingFaqEn: FaqItem[] = [
  {
    q: "What types of case studies does Velyq generate?",
    a: "Profitability, market sizing, market entry, M&A, growth strategy, pricing, cost reduction, new product launch, turnaround. Plus sector cases (tech, retail, banking, healthcare, energy) and reconstructed McKinsey/BCG/Bain house cases.",
  },
  {
    q: "Does the AI challenge you like a real MBB interviewer?",
    a: "Yes. The AI interrupts when you go vague, challenges your assumptions, injects data mid-case, asks you to synthesize Top-Down (Pyramid Principle), and scores your communication, structure and MECE rigor.",
  },
  {
    q: "Does Velyq teach the classic frameworks?",
    a: "Yes. Integrated mini-modules: MECE, Pyramid Principle, Issue Tree, Profitability (Revenue/Cost), 4P Marketing, Porter 5 Forces, 3C. You learn the frameworks, apply them in cases, and the AI corrects your usage.",
  },
  {
    q: "I'm targeting McKinsey / BCG / Bain — is it a fit?",
    a: "Yes. MBB mode with rigorous cases, 45-min timing, explicit structure expected (\"Before diving in, I'd like to…\"), focus on number-led synthesis. For McKinsey PEI, a dedicated fit questions module (leadership, teamwork, entrepreneurial drive).",
  },
  {
    q: "What about Roland Berger, Kearney, Oliver Wyman, Strategy&?",
    a: "Yes. Tier-1 mode with cases less stylized than MBB but equally rigorous. For Roland Berger, focus on the industry/auto/banking cases that come up often.",
  },
  {
    q: "I'm a business / engineering student — is it for me?",
    a: "Perfect. Velyq is widely used by HEC, ESSEC, ESCP, X, CentraleSupélec students for their consulting internship/full-time interviews. Junior mode with guided cases to build intuition, then ramp up to MBB senior level.",
  },
  {
    q: "How many cases to be ready?",
    a: "For an MBB final round: 30-50 full cases over 6-8 weeks. For a Tier-2 or boutique strategy interview: 15-25 cases. Velyq alternates full cases, flash cases (15 min) and targeted drills (just market sizing, just synthesis).",
  },
];
